import { useEffect, useState } from 'react';

import { Tab } from '@mui/material';
import { UseRestrictionPolicy } from '@repo/ui';

import { STabsWrapper } from '../shared/style';
import SubTabPanel from '../shared/TabPanel';

enum RegulationPolicyTabEnums {
  'service' = 0,
}

const handleSubTabByHash = (hash?: string) => {
  switch (hash) {
    case 'service':
      return RegulationPolicyTabEnums.service;
    default:
      return RegulationPolicyTabEnums.service;
  }
};
export default function RegulationPolicy() {
  const hash = decodeURI(window.location.hash).split('#')[1];
  const subHash = hash.split('/')[1];
  const [subTabValue, setSubTabValue] = useState(handleSubTabByHash(subHash));
  const defaultSubHash = RegulationPolicyTabEnums[0];

  const handleSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSubTabValue(newValue);
    window.location.hash = `#regulation/${RegulationPolicyTabEnums[newValue] ?? defaultSubHash}`;
  };

  useEffect(() => {
    if (!subHash) {
      window.location.hash = `#regulation/${defaultSubHash}`;
    }
  }, [subHash]);

  return (
    <>
      <STabsWrapper value={subTabValue} onChange={handleSubTabChange}>
        <Tab label="서비스 운영정책" />
      </STabsWrapper>

      <SubTabPanel index={RegulationPolicyTabEnums.service} value={subTabValue}>
        <UseRestrictionPolicy />
      </SubTabPanel>
    </>
  );
}
